import React from 'react'

function Title(props) { 
  return <title>{`${props.url == "Test Suites" ? "Test Cases" : props.url} - Test Platform`}</title>
}

export default Title